import styles from "./styles.module.css";
import React, { useRef, useState } from "react";

const AssinaturaContrato = () => {
  const containerRef = useRef(null);
  const [widget, setWidget] = useState(null);
  const [requestSignatureId, setRequestSignatureId] = useState("");

  const loadWidget = () => {
    if (widget) {
      widget.unmount(); // Desmonta o widget anterior, se existir
    }

    const newWidget = new window.Clicksign(requestSignatureId);
    newWidget.endpoint = "https://sandbox.clicksign.com";
    newWidget.origin = window.origin;

    newWidget.mount(containerRef.current);

    newWidget.on("loaded", () => console.log("loaded!"));
    newWidget.on("signed", () => console.log("signed!"));
    newWidget.on("resized", (event) => {
      console.log("resized!");
      containerRef.current.style.height = `${event.data.height}px`;
    });

    setWidget(newWidget);
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.paper}>
          <div>
            <input
              type="text"
              placeholder="Enter request_signature_id"
              value={requestSignatureId}
              onChange={(e) => setRequestSignatureId(e.target.value)}
            />
            <button onClick={loadWidget}>Load</button>
            <div
              ref={containerRef}
              style={{
                height: "600px",
                border: "1px solid #ccc",
                marginTop: "16px",
              }}
            ></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AssinaturaContrato;
